/**
 * Outbound calling — physician browser leg
 * Uses AWS Chime SDK (via window.startChimePSTNCall / window.stopChimePSTNCall in bundle.js)
 */

// DOES THIS PANEL HAVE A PATIENT? client_id is rendered from a PHP (int) cast, so a panel opened with no
// patient -- the Caller tile -- carries client_id='0'. '0' is a NON-EMPTY STRING and therefore TRUTHY in
// JS, so every truthiness test on this attribute reads "has a patient" on exactly the path that has none.
// Parse it, in one place, rather than testing the attribute at each call site.
function staff_call_patient_id($el)
{
  return parseInt($el.attr('client_id'), 10) || 0;
}

window.set_outbound_call_buttons = function(is_calling, panel)
{
  var $panel = panel ? $(panel) : (window.ndd_active_outbound_call_panel || $('.staff_call_panel:last'));
  if(!$panel.length || !$panel[0].isConnected)
    return;

  var $start_button = $panel.find('.start_phone_call_button');
  var $end_button = $panel.find('.end_phone_call_button');
  $panel.find('.staff_call_dialpad_toggle').prop('disabled', is_calling);

  // hide_me carries no !important, so ONE .show() or .hide() anywhere leaves an inline display that
  // this function can never override again -- the button is then stuck for the life of the page.
  // Clearing it here makes the class the only thing deciding, whatever else has touched them.
  $start_button.css('display', '');
  $end_button.css('display', '');

  if(is_calling)
  {
    $start_button.addClass('hide_me').prop('disabled', true);
    $end_button.removeClass('hide_me');
    return;
  }

  $start_button.removeClass('hide_me').prop('disabled', false);
  $end_button.addClass('hide_me');
  $panel.find('.staff_call_transcribing_indicator').addClass('hide_me');

  // the calling screen goes back to its resting state. The timer is stopped here rather than at each
  // of the four places a call can end, because this is the one function every one of them calls.
  if(window.staff_call_stop_timer)
    window.staff_call_stop_timer();
  $panel.find('.staff_call_stage_timer').text('');
  staff_call_reset_mute($panel);
  staff_call_reset_speaker($panel);

  // RELEASE THE ROUTE, not just the button. An override outlives the call it was set for: the next alert
  // sound then comes out of the speaker, and on Android a communication mode we took is never given back.
  // Safe on every path that lands here, including a call that failed before it was placed.
  staff_call_audio_route('speaker_release');

  // call_in_progress is what the stylesheet reads to raise the calling stage over the panel, on the drawer
  // AND on the workbench host. Removing it only for the drawer left the workbench showing a dead calling
  // screen after every call, with the setup controls underneath it unreachable.
  $panel.removeClass('call_in_progress');
  $panel.closest('.visit_fs_call_host').removeClass('call_in_progress');
  $panel.find('.staff_call_number_choices, .staff_call_transcribe').removeClass('hide_me');
  $panel.find('.staff_call_other_number_form').toggleClass('hide_me', !$panel.find(".staff_call_number_tile[data_choice='other']").hasClass('selected'));

  // A CALL ENDS BACK WHERE IT STARTED. Opened from the Caller tile there is no patient and no saved
  // number, so the keypad IS the screen -- the panel is a phone. Dropping back to the number choices
  // after a call shows a tile and a form the provider never chose and has to leave again to dial the
  // next number. With a patient the choices are the right place to land: the saved number is there.
  if(!staff_call_patient_id($panel.find('.start_phone_call_button')))
    staff_call_set_dialpad(staff_call_container($panel.find('.start_phone_call_button')), true, false);
};

// The small line above the caller-ID selector names the practice, because the option text is the number.
// Kept in step here rather than rendered into the option, where it would not fit.
$(document).on('change', '.staff_call_from_select', function()
{
  $(this).closest('.staff_call_from_cell, .staff_call_from_row')
    .find('.staff_call_from_practice')
    .text($(this).find('option:selected').attr('data_label') || '');
});

// SPEAKER / EARPIECE. The route is the operating system's to decide: the call audio is in the WebView's
// WebRTC stack, setSinkId() is not implemented in Safari or either WebView, and with the microphone
// captured both platforms put the audio on the earpiece. So this control is a request to the native layer
// and nothing else -- window.webkit.messageHandlers.iosCallControl, which the Android shim maps to the
// same place.
//
// IT IS HIDDEN UNTIL THE NATIVE LAYER ANSWERS. iosCallControl has existed since before it could route
// audio and neither the user agent nor the shim carries a build number, so the presence of the handler
// proves nothing. Asking for the current route and waiting for the reply is the only signal that works on
// both platforms and on every build: a browser never answers, an older app never answers, and the button
// stays absent rather than present and dead.
function staff_call_audio_route(action)
{
  if(!window.webkit || !window.webkit.messageHandlers || !window.webkit.messageHandlers.iosCallControl)
    return false;

  window.webkit.messageHandlers.iosCallControl.postMessage(action);
  return true;
}

// The native side calls this with the route that RESULTED, never the one that was asked for -- a refused
// override leaves the button telling the truth about where the audio is. It is also called unprompted when
// headphones arrive or a call is interrupted, because the system moves the route on its own.
window.nddNativeAudioRoute = function(payload)
{
  var state = payload || {};
  var $button = $('.staff_call_speaker_button');
  if(!$button.length)
    return;

  // the reply is the capability signal, so this is where the control first appears
  $button.removeClass('hide_me');

  // A wired or Bluetooth output is the provider's own choice of hardware and outranks this button, so the
  // control says so instead of offering a switch that the headset would immediately overrule.
  if(state.external)
  {
    $button.prop('disabled', true).removeClass('speaker_on').attr('aria-pressed', 'false');
    $button.find('.staff_call_round_icon i').attr('class', 'bi bi-headphones');
    $button.find('.staff_call_round_label').text('Headset');
    return;
  }

  var on = !!state.speaker;
  $button.prop('disabled', false).toggleClass('speaker_on', on).attr('aria-pressed', on ? 'true' : 'false');
  $button.find('.staff_call_round_icon i').attr('class', on ? 'bi bi-volume-up-fill' : 'bi bi-volume-down-fill');
  $button.find('.staff_call_round_label').text('Speaker');
};

$(document).on('click', '.staff_call_speaker_button', function()
{
  if($(this).prop('disabled'))
    return false;

  // No optimistic repaint. The press is a request the system can refuse, and the reply is what moves the
  // button -- otherwise it would show speaker while the audio stayed in the provider's ear.
  staff_call_audio_route('speaker_toggle');
  return false;
});

function staff_call_reset_speaker(panel)
{
  // hide_me carries no !important, so clear any inline display the same way the two call buttons do.
  $(panel).find('.staff_call_speaker_button')
    .css('display', '')
    .addClass('hide_me')
    .prop('disabled', false)
    .removeClass('speaker_on')
    .attr('aria-pressed', 'false');
  $(panel).find('.staff_call_speaker_button .staff_call_round_icon i').attr('class', 'bi bi-volume-up-fill');
  $(panel).find('.staff_call_speaker_button .staff_call_round_label').text('Speaker');
}

// MUTE. The Chime leg owns the audio session, so it owns the toggle; this only reports what it did.
// The button is disabled until that session exists and re-disabled when the call ends, so it can never
// be pressed into nothing.
function staff_call_reset_mute(panel)
{
  $(panel).find('.staff_call_mute_button')
    .prop('disabled', true)
    .removeClass('muted')
    .attr('aria-pressed', 'false')
    .find('.staff_call_round_label').text('Mute');
  $(panel).find('.staff_call_mute_button .staff_call_round_icon i').attr('class', 'bi bi-mic-mute-fill');
}

$(document).on('click', '.staff_call_mute_button', function()
{
  if(!window.toggleChimePSTNMute)
    return false;

  var muted = window.toggleChimePSTNMute();

  // null means there was no live audio session, so nothing is claimed on screen
  if(muted !== true && muted !== false)
    return false;

  $(this).toggleClass('muted', muted).attr('aria-pressed', muted ? 'true' : 'false')
    .find('.staff_call_round_label').text(muted ? 'Unmute' : 'Mute');
  $(this).find('.staff_call_round_icon i').attr('class', muted ? 'bi bi-mic-fill' : 'bi bi-mic-mute-fill');
  return false;
});

// The call timer runs from the moment the far party answers, not from when the call was placed, so it
// reads as the length of the conversation and matches the duration the call record stores.
var staff_call_timer_interval = null;

window.staff_call_start_timer = function()
{
  window.staff_call_stop_timer();

  var started = Date.now();
  var $timer = (window.ndd_active_outbound_call_panel || $('.staff_call_panel:last')).find('.staff_call_stage_timer');
  $timer.text('0:00');

  staff_call_timer_interval = setInterval(function()
  {
    if(!$timer.length || !$timer[0].isConnected)
      return window.staff_call_stop_timer();

    var seconds = Math.floor((Date.now() - started) / 1000);
    $timer.text(Math.floor(seconds / 60) + ':' + ('0' + (seconds % 60)).slice(-2));
  }, 1000);
};

window.staff_call_stop_timer = function()
{
  if(staff_call_timer_interval)
    clearInterval(staff_call_timer_interval);
  staff_call_timer_interval = null;
};

// enabled by the Chime leg once the audio session exists
window.staff_call_enable_mute = function()
{
  (window.ndd_active_outbound_call_panel || $('.staff_call_panel:last')).find('.staff_call_mute_button').prop('disabled', false);
};

// open the call panel. With a client_id it is about that patient (saved number or a different one);
// without one it is a plain outbound call — e.g. a voicemail callback — prefilled with prefill_number.
window.open_staff_dialer = function(params)
{
  if(window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.requestMicPermission)
    window.webkit.messageHandlers.requestMicPermission.postMessage(null);

  // params.target is the workbench's call host: the dialer belongs in the column the provider is
  // already looking at rather than a drawer over the visit. Callers outside the workbench pass
  // nothing and get the drawer, unchanged.
  var $target = params.target ? $(params.target) : null;
  var $drawer = $target ? null : add_window('prevent_swipe_close');
  var $destination = $target || $drawer;
  var request_token = {};
  $destination.data('staff_call_request_token', request_token);
  var requested_client_id = String(params.client_id || '');
  var requested_appointment_id = String(params.appointment_id || '');
  var $source_shell = $target ? $target.closest('.visit_fs_shell') : $();

  var single_input_array = {};
  single_input_array['client_id'] = params.client_id || '';
  single_input_array['appointment_id'] = params.appointment_id || '';
  single_input_array['prefill_number'] = params.prefill_number || '';
  single_input_array['number_source'] = params.number_source || '';

  $.post('shared_ajax_functions5.php', {dowhat: 'staff_initiate_phonecall', single_input_array: single_input_array}, function(data)
  {
    if(!$destination[0].isConnected || $destination.data('staff_call_request_token') !== request_token)
      return;

    // A response for an earlier visit must not populate a still-connected panel after the
    // provider has opened another patient. The workbench carries its own visit identity;
    // drawers are valid only while they remain the frontmost side window.
    var stale_workbench = $target && (
      String($source_shell.attr('client_id') || '') !== requested_client_id ||
      String($source_shell.attr('appointment_id') || '') !== requested_appointment_id ||
      !$source_shell.closest('.visit_fs_overlay').is($('.visit_fs_overlay:last'))
    );
    var stale_drawer = !$target && !$drawer.is($('.left_sidewindow_class:last'));
    if(stale_workbench || stale_drawer)
    {
      if(stale_drawer)
        $drawer.closest('.side_window_subcontainer').remove();
      return;
    }

    console.log(data);
    var json = $.parseJSON(data);

    if(json.type == 'error')
    {
      showToast(json.display);
      return false;
    }

    // The number field formats as it is typed, the same as every other phone input. The helper
    // binds one delegated handler on document and the staff page never calls it, so the dialer
    // binds it on first open and the flag keeps a second dialer from binding it twice.
    if(typeof add_phone_inputs === 'function' && !window.ndd_phone_inputs_bound)
    {
      add_phone_inputs();
      window.ndd_phone_inputs_bound = true;
    }

    if($target)
    {
      $target.html(json.display).removeClass('hide_me');
      $target.closest('.visit_fs_shell').addClass('call_open');

      // the panel's back arrow closes a drawer, and there is none here
      $target.find('.close_side_menu_button')
        .removeClass('close_side_menu_button')
        .addClass('close_workbench_call');

      // a fresh panel has no call on it yet
      $target.removeClass('call_in_progress');

      return;
    }

    $drawer.html(json.display).css('background', '#f2f2f2');
    var $panel = $drawer.find('.staff_call_panel');
    $panel.addClass('staff_call_drawer');

    // Opened from the dashboard's Caller tile there is no patient and no number to start from, so the panel
    // opens as a keypad rather than on a screen whose only live control is the keypad button. Set before the
    // drawer is shown, so it animates in already in keypad mode instead of switching once it has arrived.
    if(params.dialpad)
      staff_call_set_dialpad($panel, true);

    $drawer.show().animate({right: 0}, 200);

    var target_element = $drawer.find('.mchat_messages').get(0);
    if(target_element)
      bodyScrollLock.disableBodyScroll(target_element);
  });
};

$(document).on('click', '.staff_initiate_phonecall', function()
{
  var params = {client_id: $(this).attr('client_id'), appointment_id: $(this).attr('appointment_id')};
  var $shell = $(this).closest('.visit_fs_shell');

  // outside the workbench, and on anything too narrow for the column, the dialer is a drawer
  if(!$shell.length || !$shell.find('.visit_fs_call_host').length)
  {
    window.open_staff_dialer(params);
    return;
  }

  // A call placed during a live video is a change of modality, not a second channel: the dialer
  // would take the column the video is in and the patient would be on two at once. Confirmed
  // over the video first. Before a call is up — including during the camera check — there is
  // nothing to displace, so it just opens.
  if($shell.hasClass('video_live'))
  {
    $shell.data('pending_call_params', params);
    $shell.find('.visit_fs_convert_warning').removeClass('hide_me');
    return;
  }

  params.target = $shell.find('.visit_fs_call_host').first();
  window.open_staff_dialer(params);
});

$(document).on('click', '.cancel_convert_to_phone', function()
{
  $(this).closest('.visit_fs_shell').find('.visit_fs_convert_warning').addClass('hide_me');
  return false;
});

// Ends the video through the platform's own hangup rather than tearing the meeting down here, so
// whatever that path checks before a visit loses its video still runs. The dialer opens once it is
// down; if that path asks the provider to confirm ending the visit, they answer it first.
$(document).on('click', '.confirm_convert_to_phone', function()
{
  var $shell = $(this).closest('.visit_fs_shell');
  var params = $shell.data('pending_call_params') || {};

  $shell.find('.visit_fs_convert_warning').addClass('hide_me');
  $shell.find('.visit_fs_video_live_host .disconnect_video_class').first().click();

  var waited = 0;
  var wait_for_video_down = setInterval(function()
  {
    waited += 300;

    if(!$shell.hasClass('video_live'))
    {
      clearInterval(wait_for_video_down);
      params.target = $shell.find('.visit_fs_call_host').first();
      window.open_staff_dialer(params);
      return;
    }

    // the hangup asked the provider something and is waiting on them; the dialer is not opened
    // over an unanswered question
    if(waited >= 9000)
      clearInterval(wait_for_video_down);
  }, 300);

  return false;
});

// The container the keypad state lives on. closest() with both selectors returns whichever is
// nearer, and .staff_call_panel sits INSIDE the workbench host — so the class landed on the panel
// while the CSS was looking at the host, and the keypad never appeared.
function staff_call_container($el)
{
  var $host = $el.closest('.visit_fs_call_host');
  return $host.length ? $host : $el.closest('.staff_call_panel');
}

// Keypad mode: the header control opens it, and becomes the way back out. Opening it selects the
// typed-number choice, because the keypad types into that field and the call has to be placed
// against what is on screen rather than the saved number sitting behind it.
function staff_call_set_dialpad($host, open, restore_saved)
{
  if(!open)
  {
    var active_field = document.activeElement;
    if(active_field && $host.has(active_field).length && $(active_field).is('input'))
      active_field.blur();
    $host.removeClass('native_keyboard_open');
  }

  $host.toggleClass('dialpad_open', open);

  // The compact drawer already has a numeric keypad. Keep the number display read-only while
  // that keypad is shown so iOS does not open a second keyboard or resize the drawer.
  if($host.hasClass('staff_call_drawer'))
    $host.find('.staff_call_entered_number').prop('readOnly', open);

  var $toggle = $host.find('.staff_call_dialpad_toggle');
  $toggle.html(open ? "<i class='bi bi-x-lg'></i>" : "<i class='bi bi-grid-3x3-gap-fill'></i>");
  $toggle.attr({'aria-label': open ? 'Close the keypad' : 'Show the keypad', title: open ? 'Close' : 'Keypad'});

  if(open)
    $host.find(".staff_call_number_tile[data_choice='other']").trigger('click');
  else if(restore_saved !== false && $host.is('.staff_call_panel.has_saved_number:not(.has_prefill_number)'))
    $host.find(".staff_call_number_tile[data_choice='saved']").trigger('click');
}

$(document).on('click', '.staff_call_dialpad_toggle', function()
{
  var $host = staff_call_container($(this));
  staff_call_set_dialpad($host, !$host.hasClass('dialpad_open'));
  return false;
});

// The relationship field still needs the device keyboard after a number is entered.
$(document).on('focusin', '.staff_call_drawer .staff_call_relationship', function()
{
  $(this).closest('.staff_call_drawer').addClass('native_keyboard_open');
});

$(document).on('focusout', '.staff_call_drawer .staff_call_relationship', function()
{
  var $panel = $(this).closest('.staff_call_drawer');
  setTimeout(function()
  {
    if($panel[0].isConnected && !$panel.find('.staff_call_relationship').is(':focus'))
      $panel.removeClass('native_keyboard_open');
  }, 350);
});

// Prevent a touch on the read-only number display from focusing and scrolling it. Number entry
// stays on the visible keypad, with no viewport change.
$(document).on('pointerdown', '.staff_call_drawer.dialpad_open .staff_call_entered_number', function(e)
{
  e.preventDefault();
});

// choosing the typed-number tile is the same intent as reaching for the keypad
$(document).on('click', ".staff_call_number_tile[data_choice='other']", function()
{
  var $host = staff_call_container($(this));
  if(!$host.hasClass('dialpad_open'))
    staff_call_set_dialpad($host, true);
});

// Keys type into the number field. A plain number goes through the field's own input event so the phone
// mask formats what the keypad produces exactly as it formats what a keyboard produces. * and # are on the
// keypad because a phone's keypad has them, and they are typed rather than ignored -- but the mask strips
// anything that is not a digit, so a number carrying one is written straight into the field instead, and
// the server refuses to dial it. What would make those two keys do their real job is sending them as DTMF
// once the call is up, which the telephony application does not do yet (task #4950).
function staff_call_dial_string(field)
{
  return (field.value.match(/[0-9*#]/g) || []).join('');
}

function staff_call_write_dial_string($host, field, dialled)
{
  if(/^[0-9]*$/.test(dialled))
  {
    field.value = dialled;
    field.dispatchEvent(new Event('input', {bubbles: true}));
  }
  else
  {
    field.value = dialled;
  }

  // delete appears beside the call button only once there is something to delete
  $host.toggleClass('has_digits', dialled.length > 0);
}

$(document).on('click', '.staff_call_dialpad_key, .staff_call_dialpad_back', function()
{
  var $host = staff_call_container($(this));
  var field = $host.find('.staff_call_entered_number').get(0);
  if(!field)
    return false;

  var dialled = staff_call_dial_string(field);

  if($(this).hasClass('staff_call_dialpad_back'))
    dialled = dialled.slice(0, -1);
  else
    dialled += $(this).attr('data_key');

  staff_call_write_dial_string($host, field, dialled);

  return false;
});

// typing on the device keyboard has to move the delete button the same way the keypad does
$(document).on('input', '.staff_call_entered_number', function()
{
  staff_call_container($(this)).toggleClass('has_digits', staff_call_dial_string(this).length > 0);
});

// TRANSCRIPTION CONTROLS (CMR-2026-10-24-423). The toggle asks for two things at once: the spoken notice to
// the party called and the transcription itself. They are one switch on the server too, so nothing is ever
// transcribed that the notice did not precede.
$(document).on('change', '.staff_call_transcribe_toggle', function()
{
  $(this).closest('.staff_call_transcribe').toggleClass('transcribe_on', $(this).is(':checked'));
});

$(document).on('click', '.staff_call_purpose_tile', function()
{
  var $choices = $(this).closest('.staff_call_purpose_choices');
  $choices.find('.staff_call_purpose_tile').removeClass('selected');
  $(this).addClass('selected');
});

// Offered once the call has ended and its transcript holds something. The draft is written on the server into
// the record the call's purpose selects, so nothing clinical passes through this browser to be saved.
window.staff_call_offer_note = function(transaction_id, segment_count)
{
  var $offer = $('.staff_call_note_offer:last');
  if(!$offer.length)
    return;

  $offer.find('.staff_call_note_offer_count').text(segment_count === 1 ? '1 passage was transcribed.' : segment_count + ' passages were transcribed.');
  $offer.find('.staff_call_draft_note_button').attr('transaction_id', transaction_id);
  $offer.removeClass('hide_me');
};

$(document).on('click', '.staff_call_draft_note_button', function()
{
  var $button = $(this);
  var single_input_array = {};
  single_input_array['transaction_id'] = $button.attr('transaction_id');
  single_input_array['template_id'] = $button.attr('template_id') || '';

  $('.mybackspinner').show();
  $button.attr('disabled', true);
  $('.staff_call_errors').hide();

  $.post('shared_ajax_functions12.php', {dowhat: 'generate_call_note', single_input_array: single_input_array}, function(data)
  {
    var json = $.parseJSON(data);
    $('.mybackspinner').hide();

    if(json.type == 'error')
    {
      $button.attr('disabled', false);
      $('.staff_call_errors:last').hide().html(json.display).fadeIn();
      return false;
    }

    // the server rendered the visit's notes; replace that container rather than building any of it here.
    // The visit may not be on screen at all (a call placed from somewhere other than the workbench), in which
    // case there is nothing to refresh and the draft is waiting in the chart.
    var $notes = $('.clinical_notes_container[appointment_id="' + json.appointment_id + '"]');
    if($notes.length && json.notes_html)
      $notes.replaceWith(json.notes_html);

    $button.closest('.staff_call_note_offer').addClass('hide_me');
    showToast('The note was drafted from the call. Review and sign it.');
  });

  return false;
});

$(document).on('click', '.close_workbench_call', function()
{
  var $shell = $(this).closest('.visit_fs_shell');

  $shell.find('.visit_fs_call_host').addClass('hide_me').empty();
  $shell.removeClass('call_open');

  return false;
});

// a phone number in a patient's message (linked server-side for staff) opens the dialer prefilled for that visit
$(document).on('click', '.message_phone_call_link', function(e)
{
  e.stopPropagation();
  window.open_staff_dialer({client_id: $(this).attr('client_id'), appointment_id: $(this).attr('appointment_id'), prefill_number: $(this).attr('phone_number'), number_source: 'message'});
  return false;
});

// choose between the patient's saved number and a typed-in one
$(document).on('click', '.staff_call_number_tile', function()
{
  var $panel = $(this).closest('.staff_call_panel');
  $panel.find('.staff_call_number_tile').removeClass('selected');
  $(this).addClass('selected');

  if($(this).attr('data_choice') == 'other')
  {
    $panel.find('.staff_call_other_number_form').removeClass('hide_me');
    // The workbench number remains editable; the compact drawer uses its on-screen keypad.
    if(!staff_call_container($(this)).hasClass('dialpad_open'))
      $panel.find('.staff_call_entered_number').trigger('focus');
  }
  else
    $panel.find('.staff_call_other_number_form').addClass('hide_me');
});

$(document).on('click', '.staff_call_saved_number_select', function(e)
{
  e.stopPropagation();
});

$(document).on('change', '.staff_call_saved_number_select', function()
{
  var $panel = $(this).closest('.staff_call_panel');
  $panel.find('.staff_call_number_tile').removeClass('selected');
  $panel.find(".staff_call_number_tile[data_choice='saved']").addClass('selected');
  $panel.find('.staff_call_other_number_form').addClass('hide_me');
});

$(document).on('click', '.start_phone_call_button', function()
{
  var $panel = $(this).closest('.staff_call_panel');
  var choice = $panel.find('.staff_call_number_tile.selected').attr('data_choice');

  // The keypad screen is deliberately just the number and the keys. Where the call is about a
  // patient the server requires who is being called, so rather than let the call fail on it the
  // field is revealed here and asked for once there is a number to go with it. With no patient
  // the server does not ask, the field is not rendered at all, and the button places the call.
  if(choice == 'other')
  {
    var $keypad_host = staff_call_container($(this));
    var $relationship = $keypad_host.find('.staff_call_relationship');

    if($relationship.length && $keypad_host.hasClass('dialpad_open') && !$.trim($relationship.val()))
    {
      $keypad_host.addClass('needs_relationship');
      $relationship.trigger('focus');
      return false;
    }
  }

  var single_input_array = {};
  single_input_array['client_id'] = $(this).attr('client_id');
  single_input_array['appointment_id'] = $(this).attr('appointment_id');

  // which of the practice's numbers the call goes out from. The server re-checks it against the same
  // allow-list that built this control, so an edited value is refused rather than dialled.
  var $from_select = $panel.find('.staff_call_from_select');
  single_input_array['from_number'] = $from_select.length ? $from_select.val() : ($panel.find('.staff_call_from_single').attr('data_number') || '');

  // a typed-in number is sent instead of phone_id; the server validates it and requires who is being called
  if(choice == 'other')
  {
    single_input_array['entered_number'] = $panel.find('.staff_call_entered_number').val();
    single_input_array['contact_relationship'] = $panel.find('.staff_call_relationship').val();
    single_input_array['number_source'] = $(this).attr('number_source');
  }
  else
  {
    var $saved_tile = $panel.find(".staff_call_number_tile[data_choice='saved']");
    var $saved_select = $saved_tile.find('.staff_call_saved_number_select');
    single_input_array['phone_id'] = $saved_select.length ? $saved_select.val() : $saved_tile.attr('data_phone_id');
  }

  // The compact drawer needs no setup choices: patient-linked calls request the spoken notice and
  // transcription by default. The server derives an absent purpose from the verified call context.
  // The larger workbench retains its explicit controls.
  var $transcribe = $panel.find('.staff_call_transcribe_toggle');
  var compact_drawer = $panel.hasClass('staff_call_drawer');
  single_input_array['transcribe_enabled'] = compact_drawer ? (single_input_array['client_id'] ? 1 : 0) : ($transcribe.length && $transcribe.is(':checked') ? 1 : 0);
  single_input_array['call_purpose'] = compact_drawer ? '' : ($panel.find('.staff_call_purpose_tile.selected').attr('data_purpose') || '');

  // WHO THE CALLING SCREEN SAYS YOU ARE CALLING: the patient's name where there is one, with the number
  // they are being reached on underneath it, because a provider needs to see WHICH of a patient's numbers
  // is ringing. With no patient the number is the whole answer and stands alone.
  var callee_number = choice == 'other'
    ? $.trim($panel.find('.staff_call_entered_number').val())
    : $.trim(($panel.find('.staff_call_saved_number_select option:selected').text()
        || $panel.find(".staff_call_number_tile[data_choice='saved'] .tile_primary").text()).split('\u2014')[0]);
  var callee_name = staff_call_patient_id($(this)) ? $.trim($panel.find('.staff_call_patient_name').text()) : '';

  $panel.find('.staff_call_stage_callee').text(callee_name || callee_number);
  $panel.find('.staff_call_stage_sub').text(callee_name ? callee_number : '');
  $panel.find('.staff_call_stage_timer').text('');
  staff_call_reset_mute($panel);
  staff_call_reset_speaker($panel);

  // Ask the native layer where the audio is. The reply reveals the speaker control and sets its state; no
  // reply -- a browser, or an app build without the handler -- leaves it absent.
  staff_call_audio_route('speaker_state');

  window.ndd_active_outbound_call_panel = $panel;
  staff_call_set_dialpad(staff_call_container($(this)), false, false);
  $panel.addClass('call_in_progress');
  $panel.closest('.visit_fs_call_host').addClass('call_in_progress');
  $panel.find('.staff_call_errors').hide();
  $panel.find('.calling_lifecycle_display').html('Calling...');
  window.set_outbound_call_buttons(true, $panel);

  $.post('shared_ajax_functions5.php', {dowhat: 'start_phone_call_button', single_input_array: single_input_array}, function(data)
  {
    if(!$panel[0].isConnected)
      return;

    console.log(data);
    var json = $.parseJSON(data);

    if(json.type == 'error')
    {
      $panel.find('.calling_lifecycle_display').html('Ready to call');
      $panel.removeClass('call_in_progress');
      $panel.closest('.visit_fs_call_host').removeClass('call_in_progress');
      $panel.find('.staff_call_errors').hide().html(json.display).fadeIn();
      window.set_outbound_call_buttons(false, $panel);
      return false;
    }

    // the choice is locked once the call is placed
    $panel.find('.staff_call_number_choices, .staff_call_other_number_form').addClass('hide_me');
    $panel.find('.staff_call_transcribe').addClass('hide_me');
    if(json.transcribe)
      $panel.find('.staff_call_transcribing_indicator').removeClass('hide_me');

    $panel.find('.end_phone_call_button')
      .attr('transaction_id', json.transaction_id)
      .attr('meeting_id', json.meeting_id);

    window.startChimePSTNCall(json.meeting, json.attendee, json.transaction_id, json.meeting_id, !!json.transcribe, json.call_purpose || '');
  });
});


$(document).on('click', '.end_phone_call_button', function()
{
  var $panel = $(this).closest('.staff_call_panel');
  var transaction_id = $(this).attr('transaction_id');
  var meeting_id     = $(this).attr('meeting_id');

  if(window.stopChimePSTNCall)
    window.stopChimePSTNCall();

  $panel.find('.calling_lifecycle_display').text('Call ended.');
  window.set_outbound_call_buttons(false, $panel);

  //tear down Chime
  var single_input_array = {};
  single_input_array['transaction_id'] = transaction_id;
  single_input_array['meeting_id']     = meeting_id;
  $.post('shared_ajax_functions5.php', {dowhat: 'end_phone_call_button', single_input_array: single_input_array}, function(data)
  {
    console.log(data);
  });

  //update DB
  if(transaction_id)
  {
    var status_array = {};
    status_array['call_sid']      = transaction_id;
    status_array['event']         = 'ended';
    status_array['ended_reason']  = 'staff_ended';
    $.post('shared_ajax_functions5.php', {dowhat: 'update_outbound_call_status', single_input_array: status_array}, function(data)
    {
      console.log('staff ended call status update:', data);
    });
  }
});
